var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { DocumentScannerOutlined } from '@mui/icons-material';
import { Button, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Config } from '../../../api/config';
import { InstallBaseURL, SearchCustomerURL } from '../../../api/url';
import { SearchIconNew } from '../../../assets/images';
import { MuiStack } from '../../../components';
import HeaderDetails from '../../../components/atoms/headerDetails';
import SearchBarByTypes from '../../../components/molecules/searchBarByTypes';
import { useWidth } from '../../../components/molecules/useWidth';
import { SearchStateE } from '../../../constants';
import { showLoader, showNotification } from '../../../redux/commonSlice';
import { getByIdAPI, resetState, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import ScannerComponent from './scannerComponent';
import SelectInstallbaseAndRider from './selectInstallbaseAndRider';
import { Get } from '../../../api/api';
import { handleServerSideErrors } from '../../../utils/utils';
export default function SearchByTypeIndex(props) {
    var _this = this;
    var headerTitle = props.headerTitle, SystemName = props.SystemName, isCheckBoxVisible = props.isCheckBoxVisible, validateDocumentURL = props.validateDocumentURL, parentComponent = props.parentComponent, createDocumentURL = props.createDocumentURL, headerBackClick = props.headerBackClick, onSuccessfullDocumentCreate = props.onSuccessfullDocumentCreate, module = props.module, createAndEditFlow = props.createAndEditFlow;
    var installBaseFindError = useAppSelector(function (state) { return state.crud; }).installBaseFindError;
    var dispatch = useAppDispatch();
    var _a = useState(SearchStateE.toSearch), SearchState = _a[0], setSearchState = _a[1];
    var _b = useState("RegistrationNo"), selectedOption = _b[0], setSelectedOption = _b[1];
    var _c = useState(''), searchText = _c[0], setSearchText = _c[1];
    var _d = useState([]), autocompleteOptions = _d[0], setAutocompleteOptions = _d[1];
    var _e = useState([]), searchedVehicles = _e[0], setSearchedVehicles = _e[1];
    var _f = useState(null), searchedCustomer = _f[0], setSearchedCustomer = _f[1];
    var _g = useState(false), searchTextEmpty = _g[0], setSearchTextEmpty = _g[1];
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _h = useState(null), vehicleSelected = _h[0], setVehicleSelected = _h[1];
    var _j = useState(false), showScanner = _j[0], setShowScanner = _j[1];
    var _k = useState("MobileNumber"), searchType = _k[0], setSearchType = _k[1];
    var _l = useState(""), searchValue = _l[0], setSearchValue = _l[1];
    var isXs = useMediaQuery('(max-width:600px)');
    useEffect(function () {
        dispatch(resetState(["installBaseFindError", "installbaseSearchResult", "installbaseDetailsById"]));
    }, []);
    var handleHeaderBackClick = function () {
        headerBackClick();
    };
    var onClickSearchIcon = function () {
        if (selectedOption === "RegistrationNo") {
            if (searchText.length >= 4) {
                getInstallBase(searchText);
            }
        }
        else if (selectedOption === "VinNo") {
            if (searchText.length >= 17) {
                getInstallBase(searchText);
            }
        }
        else if (searchText.length >= 3) {
            if (selectedOption === "MobileNumber" || selectedOption === "Email") {
                fetchData(searchText);
            }
        }
        else {
            setAutocompleteOptions([]);
        }
    };
    var onSearchIcon = function (searchValue, searchOption) {
        if (searchOption === "RegistrationNo") {
            if (searchValue.length >= 4) {
                getInstallBase(searchValue);
            }
        }
        else if (searchOption === "VinNo") {
            if (searchValue.length >= 17) {
                getInstallBase(searchValue);
            }
        }
        else if (searchValue.length >= 3) {
            if (searchOption === "MobileNumber" || searchOption === "Email") {
                fetchData(searchValue);
            }
        }
        else {
            setAutocompleteOptions([]);
        }
    };
    var getInstallBase = function (searchValue) { return __awaiter(_this, void 0, void 0, function () {
        var request, getInstallBaseResponse, _getInstallBaseRespon, _getInstallBaseRespon2, error_1, _installBaseFindError, currentCount, newCount, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: 
                // Clear the vehicles state first and wait for it to complete
                return [4 /*yield*/, new Promise(function (resolve) {
                        setSearchedVehicles([]);
                        resolve();
                    })];
                case 1:
                    // Clear the vehicles state first and wait for it to complete
                    _b.sent();
                    console.log("searchedVehicles", searchedVehicles);
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 5, , 6]);
                    setSearchTextEmpty(false);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        Value: searchValue === null || searchValue === void 0 ? void 0 : searchValue.replace(/[^a-zA-Z0-9]/g, ''),
                        Key: selectedOption == "MobileNumber" ? "PersonId" : selectedOption
                    };
                    return [4 /*yield*/, Get("".concat(InstallBaseURL), {
                            params: request
                        })];
                case 3:
                    getInstallBaseResponse = _b.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 4:
                    _b.sent();
                    if (getInstallBaseResponse !== null && getInstallBaseResponse !== void 0 && getInstallBaseResponse.success && getInstallBaseResponse !== null && getInstallBaseResponse !== void 0 && getInstallBaseResponse.data) {
                        dispatch(setState({
                            key: "installbaseSearchResult",
                            value: getInstallBaseResponse
                        }));
                        setSearchedVehicles((getInstallBaseResponse === null || getInstallBaseResponse === void 0 || (_getInstallBaseRespon = getInstallBaseResponse.data) === null || _getInstallBaseRespon === void 0 ? void 0 : _getInstallBaseRespon.InstallBase) || []);
                        setSearchedCustomer(getInstallBaseResponse === null || getInstallBaseResponse === void 0 || (_getInstallBaseRespon2 = getInstallBaseResponse.data) === null || _getInstallBaseRespon2 === void 0 ? void 0 : _getInstallBaseRespon2.Customer);
                    }
                    else {
                        dispatch(setState({
                            key: "installbaseSearchResult",
                            value: null
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        setSearchedCustomer(null);
                        setSearchedVehicles([]);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    console.error('Error in getInstallBase >>>', error_1);
                    currentCount = (_installBaseFindError = installBaseFindError[searchValue]) !== null && _installBaseFindError !== void 0 ? _installBaseFindError : 0;
                    newCount = currentCount + 1;
                    dispatch(setState({
                        key: "installBaseFindError",
                        value: _objectSpread(_objectSpread({}, installBaseFindError), {}, (_a = {},
                            _a[searchValue] = newCount,
                            _a))
                    }));
                    errorMessage = handleServerSideErrors(error_1);
                    dispatch(showNotification({
                        isOpen: true,
                        message: errorMessage,
                        type: "error"
                    }));
                    dispatch(setState({
                        key: "installbaseSearchResult",
                        value: null
                    }));
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    setSearchedCustomer(null);
                    setSearchedVehicles([]);
                    return [3 /*break*/, 6];
                case 6:
                    setSearchState(SearchStateE.searchComplete);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function (searchString) { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload, _response$payload2, request, response, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    request = (_a = {},
                        _a[selectedOption] = searchString,
                        _a);
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: SearchCustomerURL,
                            request: request
                        }))];
                case 2:
                    response = _b.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.length) > 0 && response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        setAutocompleteOptions(response.payload.data);
                    }
                    else {
                        setSearchTextEmpty(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error('Error fetching autocomplete options:', error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSearchTypeChange = function (value) {
        setSelectedOption(value);
        setSearchTextEmpty(false);
        setSearchText('');
        setAutocompleteOptions([]);
        setSearchState(SearchStateE.toSearch);
    };
    var onSearchTextChange = function (value) {
        setSearchText(value.trim());
        setSearchState(SearchStateE.toSearch);
        setSearchTextEmpty(false);
    };
    var deviceType = useWidth();
    var marginLeft = deviceType === "xs" ? 2 : 3;
    var onVehicleSelect = function (item) {
        setVehicleSelected(item);
    };
    var handleScanButton = function () {
        setShowScanner(true);
        setSearchType("RegistrationNo");
    };
    var onSearch = function (numberPlate) {
        setShowScanner(false);
        setSearchValue(numberPlate);
        setSelectedOption('RegistrationNo');
        setSearchText(numberPlate);
        onSearchTextChange(numberPlate);
        onSearchIcon(numberPlate, 'RegistrationNo');
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        height: SearchState === SearchStateE.searchComplete ? (searchedVehicles === null || searchedVehicles === void 0 ? void 0 : searchedVehicles.length) > 0 || searchedCustomer ? vehicleSelected ? '100' : '94vh' : '94vh' : '94vh',
        bgcolor: '#F4F7FA'
    }, /*#__PURE__*/ React.createElement(HeaderDetails, {
        headerTitle: headerTitle,
        status: "",
        docDate: new Date().toISOString(),
        docNo: "",
        sourceDocumentNo: "",
        onHandleClick: handleHeaderBackClick,
        onMoreIconClick: function (event) { },
        isFromAppointment: false,
        parentComponent: parentComponent,
        statusKey: ''
        // onClickJobCardStatusProgress={onClickStatusStepperIcon}
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        my: 1,
        direction: "column",
        bgcolor: '#EFF2F5'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        py: 1,
        px: 2,
        rowGap: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Search")), /*#__PURE__*/ React.createElement(SearchBarByTypes, {
        SearchState: SearchState,
        handleOnClickSearchIcon: onClickSearchIcon,
        handleSelectSearchResult: getInstallBase,
        searchText: searchText,
        selectedOption: selectedOption,
        autocompleteOptions: autocompleteOptions,
        handleSelectSearchType: function (value) { return handleSearchTypeChange(value); },
        handleSearchTextChange: onSearchTextChange,
        SystemName: SystemName
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#8593A3"
    }, t("SEARCH_BY_TEXT")), isXs && Config.version.startsWith("DEV-") && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        marginTop: "10px",
        marginLeft: "5px",
        display: "flex",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 5.5,
        sm: 5.5,
        md: 5.5
    }, /*#__PURE__*/ React.createElement(Divider, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1,
        sm: 1,
        md: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        align: "center"
    }, "OR")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 5.5,
        sm: 5.5,
        md: 5.5
    }, /*#__PURE__*/ React.createElement(Divider, null))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        marginTop: "10px",
        marginLeft: "5px"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        startIcon: /*#__PURE__*/ React.createElement(DocumentScannerOutlined, null),
        fullWidth: true,
        onClick: handleScanButton
    }, t("Scan vehicle number plate")))), /*#__PURE__*/ React.createElement(ScannerComponent, {
        scannerRegex: "^([A-Z]{2}\\d{2}[A-Z]{0,2}\\d{1,4}|[A-Z]{2}\\d{2}\\n?[A-Z]{0,2}\\d{1,4}|[A-Z]{2}BH\\d{4}|\\d{1,6}\u2191|\\d{2}[A-Z]{1,2}\\d{1,4})$",
        callback: onSearch,
        openPopup: showScanner,
        setShowScanner: setShowScanner
    }))), /*#__PURE__*/ React.createElement("div", {
        style: {
            border: '1px solid #DEE4EB',
            marginLeft: '-8px',
            marginRight: '-8px',
            display: searchedVehicles.length > 0 || searchedCustomer ? 'none' : 'flex'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'space-between',
        px: 2,
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, SearchState === SearchStateE.searchComplete && /*#__PURE__*/ React.createElement(React.Fragment, null, searchedVehicles.length > 0 || searchedCustomer ?
        /*#__PURE__*/
        // <SelectVehicleAndServiceType
        //     VehiclesDetailsList={searchedVehicles}
        //     customerDetails={searchedCustomer} />
        React.createElement(SelectInstallbaseAndRider, {
            VehiclesDetailsList: searchedVehicles,
            customerDetails: searchedCustomer,
            isCheckBoxVisible: isCheckBoxVisible,
            validateDocumentURL: validateDocumentURL,
            SystemName: SystemName,
            parentComponent: parentComponent,
            createDocumentURL: createDocumentURL,
            apiRequestPayload: "",
            module: "",
            parentModuleDocumentId: "",
            onSuccessfullDocumentCreate: function (documentCreateResponse) {
                if (onSuccessfullDocumentCreate) {
                    onSuccessfullDocumentCreate(documentCreateResponse);
                }
            },
            createAndEditFlow: createAndEditFlow,
            onVehicleSelect: onVehicleSelect
        }) : /*#__PURE__*/ React.createElement(MuiStack, {
        height: "100%",
        mt: 1.5,
        spacing: 2,
        width: "100%",
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "search",
        src: SearchIconNew
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        textAlign: 'center'
    }, t("Result not found")), /*#__PURE__*/ React.createElement(Typography, {
        textAlign: 'center',
        variant: "h4",
        color: "#8593A3"
    }, "Your search ".concat((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.toLowerCase()) == 'vin no.' ? searchText === null || searchText === void 0 ? void 0 : searchText.slice(0, 17) : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.toLowerCase()) == 'reg. no.' ? searchText === null || searchText === void 0 ? void 0 : searchText.slice(0, 10) : searchText, " did not match any ").concat(selectedOption === "MobileNumber" ? t("mobile number") : selectedOption === "RegistrationNo" ? t("registration number") : selectedOption === "VinNo" ? t("vin number") : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.toLowerCase(), ". Please try again.")))), searchTextEmpty && searchText.length >= 3 && /*#__PURE__*/ React.createElement(MuiStack, {
        height: "100%",
        spacing: 2,
        width: "100%",
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "search",
        src: SearchIconNew
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        textAlign: 'center'
    }, t("Result not found")), /*#__PURE__*/ React.createElement(Typography, {
        textAlign: 'center',
        variant: "h4",
        color: "#8593A3"
    }, "Your search ".concat(searchText === null || searchText === void 0 ? void 0 : searchText.slice(0, 10), " did not match any ").concat(selectedOption === "MobileNumber" ? t("mobile number") : selectedOption === "RegistrationNo" ? t("registration number") : selectedOption === "VinNo" ? t("vin number") : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.toLowerCase(), ", Please try again."))))));
}
